"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var action_1 = require("../action");
var promiseMiddleware_1 = require("./promiseMiddleware");
function wrapThen(originalThen) {
    return function wrappedThen(onFulfilled, onRejected) {
        return originalThen.call(this, wrapInAction(onFulfilled, 'then'), wrapInAction(onRejected, 'then_rejected'));
    };
}
exports.wrapThen = wrapThen;
function wrapCatch(originalCatch) {
    return function wrappedCatch(onRejected) {
        return originalCatch.call(this, wrapInAction(onRejected, 'catch'));
    };
}
exports.wrapCatch = wrapCatch;
function wrapInAction(callback, callbackType) {
    var currentAction = promiseMiddleware_1.getCurrentAction();
    if (!currentAction || !callback) {
        return callback;
    }
    var actionName = currentAction + ' => ' + callbackType;
    return function () {
        var returnValue;
        var args = arguments;
        action_1.default(actionName)(function () {
            returnValue = callback.apply(null, args);
        })();
        return returnValue;
    };
}
